import { Component } from '@angular/core';
import { Input,Output,ViewChild,EventEmitter,TemplateRef } from '@angular/core';
import { cdkOverlayRef } from '../../custom-overlay/cdk-overlay-ref';
import { CdkOverlyayService } from '../../custom-overlay/cdk-overlyay.service';
import { Subject } from 'rxjs';
import { Inject } from '@angular/core';
import { CDK_OVERLAY_DROPDOWN } from '../../custom-overlay/cdk-overlay-injector';
import { FILE_PREVIEW_DIALOG_DATA } from 'src/app/shared/custom-overlay/cdk-overlay-injector';
// import { emit } from 'process';

@Component({
  selector: 'app-nested-dropdown-overlay',
  templateUrl: './nested-dropdown-overlay.component.html',
  styleUrls: ['./nested-dropdown-overlay.component.scss']
})


export class NestedDropdownOverlayComponent {

  @Input() data;
  @Input() valueColumn;
  @Input() statusColumn;
  @Input() displayColumn;
  @Input() origin;
  @Input() style;
  @Input() hasMultiSelect: boolean;
  @Input() placeHolder;
  @Input() label?;
  @Input() isSearch: boolean = false;
  @Input() header:string
  @Output() SelectionChange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('origin') dropdownOrigin: TemplateRef<any>;
  selectedIndex

  @Input() fontsize: string = '';
  @Input() overlaycontainer: string = '';
  initialData:any
  // overLayRef: cdkOverlayRef;

  valueArray;
  statusArray;
  displayArray;
  selectedItem;
  displayItem;
  selectedList;
  
  private _selectValue = new Subject<any>();
  $selectedValue = this._selectValue.asObservable();
  // @ViewChild('select') selectRef: ElementRef;
  index: number = 0;

  nestedIndex:number=0
  selectedEntity=[]
  entityFields:any
  searchText: string = '';
  filteredData:any

  //for controlValue Accessor
  onChange = (selectedItem: string) => { }; // this value will be sent to form
  onTouched = () => { };
  disabled: boolean = false;
  overlay_state: boolean = false;
  constructor(
    private cdkoverlayDialog: CdkOverlyayService,
    private overLayRef: cdkOverlayRef,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public DropDown: any,) { }

  // openOverlay(origin: any, component, componentInputs) {
  //   this.overLayRef = this.cdkoverlayDialog.open({
  //     data: componentInputs,
  //   },
  //     origin, component)
  //   return this.overLayRef;
  // }
  // registerOnChange(onChange: any): void { // to form - send to form which contains this control
  //   this.onChange = onChange;
  //   // console.log("onchange",this.onChange)
  // }
  // registerOnTouched(onTouched: any): void {
  //   this.onTouched = onTouched;
  // }
  // writeValue(value: any) { //from form - form which contains this control will write here  //example:default value from form
  //   this.selectedItem = value;
  //   if (this.initialData && value != null) {
  //     if (typeof (this.initialData[0]) == 'object') {
  //       if (typeof (value) == 'object' && this.hasMultiSelect) {
  //         value.forEach(element => {
  //           if (element != null) {
  //             let index = this.valueArray.findIndex((elem) => elem.toString() == element.toString()); //get display value of the given value
  //             if (index >= 0)
  //               if (this.displayItem) this.displayItem = this.displayItem + ',' + this.displayArray[index]
  //               else this.displayItem = this.displayArray[index]
  //           }
  //         });
  //       }
  //       else {
  //         let index = this.valueArray.findIndex((elem) => elem.toString() == value.toString()); //get display value of the given value
  //         if (index >= 0) this.displayItem = this.displayArray[index]
  //       }
  //     }
  //     else
  //       this.displayItem = value;
  //   }
  //   else
  //     this.displayItem = null;


  // }
  // setDisabledState(isDisabled: boolean) {
  //   this.disabled = isDisabled;
  // }
  // onKeyDown(event, origin) {
  //   switch (event.key) {
  //     case "ArrowLeft":
  //     case "ArrowUp":
  //       event.stopPropagation();
  //       if (this.index > 0) this.index = this.index - 1;
  //       else this.index = this.initialData.length - 1;
  //       this.displayItem = this.displayArray[this.index];
  //       this.selectedItem = this.valueArray[this.index];
  //       this.onChange(this.selectedItem)
  //       break;
  //     case "ArrowRight":
  //     case "ArrowDown":
  //       event.stopPropagation();
  //       if (this.index < this.initialData.length - 1) this.index = this.index + 1;
  //       else this.index = 0;
  //       this.displayItem = this.displayArray[this.index];
  //       this.selectedItem = this.valueArray[this.index];
  //       this.onChange(this.selectedItem)
  //       break;
  //     case "Enter":
  //       // this.dropdownOverlay(origin);
  //   }
  // }

  // ngDoCheck(): void {
  //   // console.log("DoCheck")
  //   //convert array of objects into array of display column names(string/nunber) and value column
  //   if (this.initialData) {
  //     if (typeof (this.initialData[0]) == 'object') {
  //       if (!this.displayColumn) this.displayColumn = 'disp' //default name of display column in the object
  //       if (!this.valueColumn) this.valueColumn = 'value'   //default name of value column in the object
  //       if (!this.statusColumn) this.statusColumn = 'status'   //default name of value column in the object
  //       this.displayArray = this.initialData.map(a => a[this.displayColumn])
  //       this.valueArray = this.initialData.map(a => a[this.valueColumn])
  //       // this.statusArray = this.initialData.map(a => { if (a.hasOwnProperty(this.statusColumn)) return a[this.statusColumn] })
  //       this.statusArray = this.initialData.filter(a => a.hasOwnProperty(this.statusColumn)).map(a => a[this.statusColumn]);
  //     }
  //     else {
  //       this.displayArray = this.initialData;
  //       this.valueArray = this.initialData;
  //     }
  //   }
    
  // }

  ngOnInit(): void {
    // this.searchText=''

//console.log("--->",this.overLayRef)

    this.displayItem = "";
    // console.log(this.DropDown)
    this.data = this.DropDown[0]
    this.isSearch=this.DropDown[1]
    this.header=this.DropDown[2]
    this.selectedIndex=this.DropDown[3]
    // console.log(this.DropDown)
    // console.log(this.isSearch)

    this.initialData=this.data ? JSON.parse(JSON.stringify(this.data)) : {}
    this.onSearchChange()
    // this.dropdownOverlay(this.dropdownOrigin)
    // console.log("data>>>>>>>.",this.initialData,"disp>>>>>>>",this.displayArray)
  }

  entityClick(entity:any){
//console.log(entity)
      if(typeof(entity.value) === "object"){
        this.initialData=entity.value
        this.searchText=''
        this.onSearchChange()
        this.selectedEntity.push(entity)
        this.nestedIndex++
      }else{
        let emitValue=[]
        emitValue=JSON.parse(JSON.stringify(this.selectedEntity))
        emitValue.push(entity)
        // console.log(entity)
        // console.log(this.selectedEntity)
        // console.log(emitValue)
        // this.cdkoverlayDialog.emitValue(emitValue,this.selectedIndex)
//console.log(this.overLayRef)
        this.overLayRef._cube.next(emitValue)
        this.overLayRef.close()
        // this.SelectionChange.emit(emitValue);
        // this._selectValue.next(emitValue)
        
      }
   

  }
  onSearchChange() {
    const search = this.searchText.toLowerCase();
    if(search.length>0){
//console.log("if")

    // Filter the finalData based on search text and group by the selected option
      this.filteredData = this.initialData.filter(item =>
          item.disp.toLowerCase().includes(search) 
      );

      this.filteredData.sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));
      // this.filteredData.sort()
      // console.log(this.filteredData)
      // this.initialData=this.filteredData
   }else{
//console.log("else")
    this.filteredData=this.initialData
    
   }
    // this.groupedData = this.groupBy(filteredData, this.dashboardService.groupByOption);
    //console.log(this.groupedData)
//console.log(this.filteredData)
}

  headerClick(head,index){
    // console.log({head},{index})
    this.selectedEntity.splice(index+1)
    this.initialData=head
    this.onSearchChange()
    // console.log(this.selectedEntity)
    
  }

  entityClear(){
    this.selectedEntity=[]
    this.nestedIndex=0
    this.initialData=this.data
    this.onSearchChange()
  }


}
